module.exports = {
    development: {
        url: "http://34.86.42.94/v3.0/",
    },
    production: {
        url: "https://recommendations.unbxd.io/v3.0/",
    },
};
